import { __assign, __rest } from "tslib";
import * as React from 'react';
import clsx from 'clsx';
import { createStyles } from '@material-ui/core/styles';
import withStyles from '@material-ui/core/styles/withStyles';
import { default as MuiPaper } from '@material-ui/core/Paper';
import { getColor, rgba } from '../styles';
var styles = function (theme) {
    var dropdownBorderColor = theme.palette.type === 'light'
        ? getColor('border.main', theme)
        : getColor('background.b2', theme);
    return createStyles({
        dropdown: {
            border: "1px solid ".concat(dropdownBorderColor),
            boxShadow: "".concat(rgba(getColor('background.b9', theme), 0.075), " 0px 0px 0px 4px"),
        },
    });
};
export var Paper = React.forwardRef(function (props, ref) {
    var _a;
    var classes = props.classes, classNameProp = props.className, variant = props.variant, elevation = props.elevation, other = __rest(props, ["classes", "className", "variant", "elevation"]);
    var className = clsx((_a = {},
        _a[classes.dropdown] = variant === 'dropdown',
        _a), classNameProp);
    return React.createElement(MuiPaper, __assign({ className: className, elevation: elevation || 0, ref: ref }, other));
});
export default withStyles(styles)(Paper);
//# sourceMappingURL=Paper.js.map